// ===================== อ่านใบ PI (PDF) ของซัพพลายเออร์ → รายการ + จำนวน + ราคา (ผู้ใช้ 1/11/2569: จำนวนต้องตาม PI · ไม่อยากพิมพ์) =====================
// ใช้ได้กับ PI แบบตารางทั่วไป: บรรทัด = ลำดับ. รายการ … จำนวน(หน่วย) ราคา/หน่วย รวม · ระบบตรวจ จำนวน × ราคา = รวม ก่อนรับบรรทัด
// โหลดตัวอ่าน PDF เฉพาะตอนกดใช้ (ไม่ทำให้หน้าอื่นช้า)
const num = (s) => Number(String(s || '').replace(/[,\s]/g, '')) || 0;

export async function pdfLines(file) {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf');
  await import('pdfjs-dist/legacy/build/pdf.worker.entry');   // ตัวอ่านทำงานในหน้าเว็บ (ไม่ต้องโหลดจากเว็บอื่น)
  const doc = await pdfjs.getDocument({ data: new Uint8Array(await file.arrayBuffer()), isEvalSupported: false }).promise;
  const out = [];
  for (let p = 1; p <= doc.numPages; p += 1) {
    const page = await doc.getPage(p);
    const { items } = await page.getTextContent();
    const rows = [];
    items.filter((it) => String(it.str || '').trim()).forEach((it) => { const x = it.transform[4], y = it.transform[5];
      let r = rows.find((q) => Math.abs(q.y - y) < 3); if (!r) { r = { y, parts: [] }; rows.push(r); } r.parts.push({ x, w: it.width || 0, s: it.str }); });
    // ชิ้นข้อความที่อยู่ติดกัน (เช่น KCQR / - / 350) ต่อกันโดยไม่เว้นวรรค · ห่างกัน = เว้นวรรค
    rows.sort((a, b) => b.y - a.y).forEach((r) => { const ps = r.parts.sort((a, b) => a.x - b.x); let s = '', end = null;
      ps.forEach((q) => { const gap = end === null ? 0 : q.x - end; s += (end !== null && gap > 1.2 && !/\s$/.test(s) && !/^\s/.test(q.s) ? ' ' : '') + q.s; end = q.x + q.w; });
      out.push(s.replace(/\s+/g, ' ').trim()); });
  }
  return out;
}

// บรรทัดรายการ: "1. KCQR-350 (H13 Filter) … 45PCS $246.55 $11,094.75" · ยอมให้ไม่มีลำดับ / ไม่มีหน่วย / ไม่มี $
const ITEM = /^(?:(\d{1,3})\s*[.)]?\s*)?(.+?)\s+([\d,]+(?:\.\d+)?)\s*([A-Za-z]{1,6})?\s+(?:US\s*)?\$?\s*([\d,]+(?:\.\d+)?)\s+(?:US\s*)?\$?\s*([\d,]+(?:\.\d+)?)$/;
export function parsePi(lines) {
  const rows = [], head = {};
  lines.forEach((l) => {
    const m = l.match(ITEM);
    if (m && !/^(sub ?total|total|deposit|balance|invoice total|grand total)/i.test(m[2])) {
      const q = num(m[3]), p = num(m[5]), amt = num(m[6]);
      if (q > 0 && p > 0 && Math.abs(q * p - amt) <= Math.max(0.05, amt * 0.01)) {
        rows.push({ description: m[2].replace(/\s+/g, ' ').trim(), qty: String(q), unit: m[4] || '', price_usd: String(p), good_code: '' }); return; }
    }
    let k;
    if (!head.pi_no && (k = l.match(/\b(?:PI|P\/I|Proforma(?: Invoice)?|Invoice)\s*(?:No\.?|Number|#)\s*:?\s*([A-Z0-9][A-Z0-9\-/]{3,})/i))) head.pi_no = k[1];
    if (!head.pi_date && (k = l.match(/\bDate\s*:?\s*(\d{1,2})[-/ ]([A-Za-z]{3}|\d{1,2})[-/ ](\d{2,4})/i))) {
      const mon = isNaN(k[2]) ? ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].indexOf(k[2].toLowerCase()) + 1 : Number(k[2]);
      const y = k[3].length === 2 ? 2000 + Number(k[3]) : Number(k[3]);
      if (mon > 0) head.pi_date = `${y}-${String(mon).padStart(2, '0')}-${String(k[1]).padStart(2, '0')}`; }
    if (!head.deposit_pct && (k = l.match(/(\d{1,3})\s*%\s*:?\s*(?:T\/T\s*)?(?:as\s*)?deposit/i))) head.deposit_pct = k[1];
    if (!head.lead_days && (k = l.match(/(\d{1,3})(?:\s*-\s*(\d{1,3}))?\s*(?:working\s*)?days/i)) && /deliver|lead|production/i.test(l)) head.lead_days = k[2] || k[1];
    if (!head.incoterm && (k = l.match(/^(?:TERMS?\s*:?\s*)?(EXW|FOB|CIF|CFR|DDP|DAP)\b/i))) head.incoterm = k[1].toUpperCase();
    if (!head.supplier && /\b(co\.?,?\s*ltd|limited|company|corp|inc)\b/i.test(l) && !/homexpert/i.test(l) && l.length < 80) head.supplier = l.replace(/\s+/g, ' ').trim();
    if (!head.total && (k = l.match(/(?:invoice total|grand total|total amount|sub ?total)\s*:?\s*(?:US\s*)?\$?\s*([\d,]+\.\d+)/i))) head.total = num(k[1]);
  });
  return { rows, head };
}
